import React from "react";
import { createPortal } from "react-dom";
import CourseManageOptions from "./CourseManageOptions";

export default function CourseAddBar(props) {
  return (
    <>
      {createPortal(
        <div className="z-5 fixed top-[57px] m-0 flex h-[120px] w-full flex-col items-center justify-center gap-4 border-b border-gray-100 bg-gray-50 p-3 text-center font-bold text-gray-700 shadow-sm sm:h-[64px] sm:flex-row sm:gap-2">
          <div className="max-w-xs">
            <CourseManageOptions {...props} linkClassName="text-base" />
          </div>
          <span>
            or{" "}
            <a
              className="text-nowrap text-gray-700 underline decoration-2 underline-offset-4 hover:decoration-[3px]"
              href="/manage-courses.php"
            >
              go back to manage courses
            </a>
          </span>
        </div>,
        document.body,
      )}
      <div className="h-[120px] sm:h-[64px]"></div>
    </>
  );
}
